"use client";

import React from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
const plans = [{
  name: "THE COMPLETE STARTUP SUITE + RMM",
  description: "Real-time monitoring, unlimited expert support, and automated security updates—all in one flat-rate partnership.",
  monthlyPrice: "110",
  yearlyPrice: "1,100",
  popular: true,
  features: ["24/7 Device Monitoring", "Unlimited Helpdesk Tickets", "Automated Security Patching", "O365 Support Included", "Direct Slack/Teams Access", "Zero Markup Licensing", "Asset Inventory Tracking", "Compliance Reporting"],
  buttonText: "Get Started"
}];
export default function SubscriptionPlans() {
  return <section data-section-id="224426" id="the-110-difference" className="py-20 bg-background text-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-5xl font-bold font-default text-foreground mb-4 tracking-tighter">
            One Price. Total Control.
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            We understand the speed of startups. Our flat-rate model provides the enterprise-grade IT infrastructure you need without the complex billing.
          </p>
        </div>

        <Tabs defaultValue="monthly" className="w-full flex flex-col items-center">
          

          <TabsContent value="monthly" className="w-full mt-0 text-center">
            <p className="text-2xl font-bold mb-4">$110 per device per month.</p>
            <p className="text-lg text-muted-foreground">We believe in a monthly billing plan, because nobody should ever feel locked in.</p>
          </TabsContent>
        </Tabs>
      </div>
    </section>;
}